export default "__VITE_ASSET__CKcRku5z__"